import React from "react";

const Loan = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
          className="u_fill"
          d="M10.167 34L2 27.22l4.681-4.681a8.98 8.98 0 014.557-2.465 8.896 8.896 0 015.143.475h5.762c.574 0 1.124.232 1.53.643.405.412.633.97.633 1.552 0 .582-.228 1.14-.634 1.552a2.147 2.147 0 01-1.529.643h-4.462a.71.71 0 00-.506.213.732.732 0 000 1.027.71.71 0 00.506.212h5.057c.36 0 .715-.077 1.044-.227a2.55 2.55 0 00.86-.641l5.453-6.31a2.224 2.224 0 013.144-.178 2.3 2.3 0 01.224 3.188l-6.808 8.044a5.348 5.348 0 01-1.815 1.37 5.275 5.275 0 01-2.21.486H12.003L10.167 34zM20.229 6.675c-.612 0-1.21.184-1.719.529a3.13 3.13 0 00-1.14 1.409 3.183 3.183 0 00-.175 1.814c.119.609.414 1.168.846 1.607a3.052 3.052 0 003.371.68 3.103 3.103 0 001.39-1.155 3.173 3.173 0 00-.39-3.97 3.055 3.055 0 00-2.196-.915h.013zM28.559 2c.618.003 1.21.255 1.646.7.436.445.68 1.047.68 1.674v10.884c0 .63-.246 1.233-.685 1.679a2.322 2.322 0 01-1.654.695h-16.66c-.621 0-1.216-.25-1.655-.695a2.392 2.392 0 01-.685-1.679V4.374c0-.63.247-1.234.685-1.679A2.322 2.322 0 0111.885 2H28.56zm-.326 5.998A4.272 4.272 0 0126.15 6.83a4.372 4.372 0 01-1.15-2.112h-9.545a4.379 4.379 0 01-1.008 1.96 4.287 4.287 0 01-1.828 1.206.586.586 0 00-.395.55v2.758c0 .123.039.242.11.34a.573.573 0 00.285.21c.702.236 1.33.652 1.828 1.206.496.555.844 1.23 1.008 1.961h9.516c.18-.8.578-1.532 1.15-2.112a4.272 4.272 0 012.081-1.167l.03-3.633z"
          fill={fill}
      />
    </svg>
);

export default Loan;
